import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { useParams } from "react-router-dom";
import { bindActionCreators } from "redux";
import { Button, Typography, Tabs } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";
import AllProperties from "./AllProperties";
import UnregisteredProperties from "./UnregisteredProperties";
import * as propertyActions from "../../../../actionCreators/Property";
import "./style/propertyListing.css";

const { TabPane } = Tabs;

const Properties = ({ loading, getProperties, getRegisteredProperties }) => {
  const history = useHistory();
  const [pageKey, setPageKey] = React.useState();
  const [pagination, setPagination] = React.useState({});
  const [selectedRows, setSelectedRows] = React.useState([]);
  const [propertyRowData, setPropertyRowData] = React.useState([]);
  const [activeTab, setActiveTab] = React.useState("");
  const { id } = useParams();

  React.useEffect(() => {
    if (id === "unregistered") {
      getProperties({ page: 0, pageSize: 10, type: "unregistered" });
    } else if (id === "registered") {
      getProperties({ page: 0, pageSize: 10, type: "existing" });
      // getRegisteredProperties({
      //   page: 1,
      //   pageSize: 10,
      // });
    }
  }, [id]);

  function tabChange(key) {
    setPageKey(key);
    setActiveTab(pageKey);
    history.push("/properties/" + key);
  }

  const handlePropertyRowData = (data) => {
    setPropertyRowData(data);
    history.push("/properties/view/" + data.id);
  };

  const handlePropertyPagination = (data) => {
    setPagination(data);
  };
  const getSelectedRows = (data) => {
    setSelectedRows(data);
  };

  return (
    <div>
      <div className="header">
        <Typography className="heading">
          Properties {pagination.count ? `(${pagination.count})` : null}
        </Typography>
        <div>
          <Button
            className="search-property-button"
            type="ghost"
            icon={<SearchOutlined />}
            onClick={() => history.push("/search-property")}
          >
            SEARCH PROPERTIES
          </Button>
        </div>
      </div>
      <div>
        <Tabs
          activeKey={id}
          defaultActiveKey={id}
          onChange={tabChange}
          className="tab-main"
          destroyInactiveTabPane
        >
          <TabPane
            tab="UNREGISTERED PROPERTIES"
            key="unregistered"
            className="tab-pane"
          >
            <UnregisteredProperties
              getPropertyData={handlePropertyRowData}
              paginationData={handlePropertyPagination}
              getSelectedRows={getSelectedRows}
            />
          </TabPane>
          <TabPane
            tab="REGISTERED PROPERTIES"
            key="registered"
            className="tab-pane"
          >
            <AllProperties
              getPropertyData={handlePropertyRowData}
              paginationData={handlePropertyPagination}
              getSelectedRows={getSelectedRows}
            />
          </TabPane>
        </Tabs>
      </div>
    </div>
  );
};

const mapStateToProps = ({ property: { loading } }) => ({
  loading,
});

const mapDispatchToProps = (dispatch) => ({
  getProperties: bindActionCreators(propertyActions.getProperties, dispatch),
  getRegisteredProperties: bindActionCreators(
    propertyActions.getRegisteredProperties,
    dispatch
  ),
  getCurrentProperty: bindActionCreators(
    propertyActions.getCurrentProperty,
    dispatch
  ),
});

Properties.propTypes = {
  getProperties: PropTypes.func.isRequired,
  getCurrentProperty: PropTypes.func.isRequired,
  getRegisteredProperties: PropTypes.func.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(Properties);
